<div class="cards-container">
  <ng-container #viewRef></ng-container>
</div>
